import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/xmark.svg'


const _withScopeId = n => (_pushScopeId("data-v-5dc3a79a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-detail-dialog"
}
const _hoisted_2 = {
  class: "product-detail-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "product-detail-container" }
const _hoisted_7 = { class: "left-infos" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "stand-container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1))
const _hoisted_12 = { class: "stands" }
const _hoisted_13 = ["onClick", "innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "product-logo"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "image-gallery"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["alt", "src"]
const _hoisted_19 = { class: "footer" }
const _hoisted_20 = { class: "image-modal-container" }
const _hoisted_21 = { class: "close-button" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  class: "product-image",
  ref: "modalImage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theme_root = _resolveComponent("theme-root")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.product.name), 1),
              (_ctx.product.info)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "infos",
                    innerHTML: _ctx.product.info
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.product.exhibitor)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "exhibitor-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openExhibitorDialog(_ctx.product.exhibitor,$event)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('exhibitor')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.product.stands)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.stands, (stand, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stand",
                          onClick: ($event: any) => (_ctx.callOpenStandDialog(stand,$event)),
                          innerHTML: (stand.getDisplayName() + (index !== _ctx.product.stands.length -1 ? ',' : ''))
                        }, null, 8, _hoisted_13))
                      }), 256))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.product.logo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: _ctx.product.getLogoUrl()
                  }, null, 8, _hoisted_15)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.product.images && _ctx.product.images.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.images, (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "product-image",
                    onClick: ($event: any) => (_ctx.openImageModal(image))
                  }, [
                    _createElementVNode("img", {
                      alt: image.text,
                      src: image.getUrl()
                    }, null, 8, _hoisted_18)
                  ], 8, _hoisted_17))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.product.themesDisplay)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.themeTrees, (three) => {
                  return (_openBlock(), _createBlock(_component_theme_root, {
                    root: three.root,
                    themes: _ctx.themes,
                    entityThemes: _ctx.product.themesDisplay
                  }, null, 8, ["root", "themes", "entityThemes"]))
                }), 256))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["image-modal", _ctx.isImageModalOpen ? 'image-model-open':'image-modal-closed'])
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeImageModal && _ctx.closeImageModal(...args)))
                }, _hoisted_23)
              ]),
              _createElementVNode("img", _hoisted_24, null, 512)
            ])
          ], 2)
        ], 512)
      ]))
    : _createCommentVNode("", true)
}